import React, {useContext, useMemo} from "react";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import FlintDropDownList from "@components/controls/FlintDropDownList";
import {ApiResponseDto, DropDownListItem, NameWithId, VivoRootModel} from "@utils/Models";
import axios from "axios";
import {ApiUrl_Common_SwitchDivision} from "@utils/Endpoints";
import styles from "./DivisionSelector.module.scss"
import {requestContextChange} from "@utils/auth/contextRequestGuard";
import useMediaQuery from "@utils/other/useMediaQuery";
import {mediaQueries} from "@utils/AppConstants";

export default function DivisionSelector() {
    const {state, handlers, utils} = useDivisionSelector();

    if (!state.divisionList.get) {
        return <div></div>;
    }
    return (
        <>
            {utils.isDesktop ?
                <FlintDropDownList className={styles.divisionSelectorDropDown}
                                   dataSource={state.divisionList.get}
                                   onItemSelected={handlers.handleDivisionSelected}
                                   usePrimitives={true}
                                   selectedValue={state.selectedDivisionId.get}/>
                :
                <FlintDropDownList<DropDownListItem> style={{minWidth: "30px"}}
                                                     className={styles.mobileDivisionSelectorDropDown}
                                                     dataSource={state.divisionList.get}
                                                     onItemSelected={handlers.handleDivisionSelected}
                                                     usePrimitives={true}
                                                     selectedValue={state.selectedDivisionId.get}/>}
        </>
    )
}

function useDivisionSelector() {
    const {claims, rootModel, update} = useAuthenticationContext();
    const isXlUp = useMediaQuery(mediaQueries.xl_Up);

    async function handleDivisionSelected(newDivision: DropDownListItem) {
        // null = a newer context request or a token change superseded this one: do not overwrite the newer context
        const model = await requestContextChange(ApiUrl_Common_SwitchDivision, newDivision.Id);
        if (model)
            update(claims, model);
        // console.log(newDivision);
    }

    const divisionList = useMemo(() => {
        return isXlUp ? rootModel?.CurrentUserProfile.DivisionList : rootModel?.CurrentUserProfile.DivisionList.map((division) => (
            {
                Name: division.IdString,
                Id: division.Id
            } as DropDownListItem));
    }, [isXlUp, rootModel?.CurrentUserProfile.DivisionList])
    
    return {
        state: {
            divisionList: {get: divisionList ?? []},
            selectedDivisionId: {get: rootModel?.CurrentUserProfile.DivisionId},
        },
        utils: {
            isDesktop: isXlUp,
        },
        handlers: {
            handleDivisionSelected
        }
    }
}